import { isEmpty } from 'lodash';
import { getBarberShopScheduleWithConflicts } from '../../../scheduleConflictsHelpers';

const getScheduleSummary = ({ shopSchedules, fieldName, shops, shopNamesById }) => {
  if (isEmpty(shopSchedules)) {
    return [];
  }

  return shopSchedules.map((shopSchedule) => {
    const otherShopsSchedules = shopSchedules.filter(
      otherShopSchedule => otherShopSchedule.shopId !== shopSchedule.shopId
    );

    const shop = shops.find(shopItem => shopItem.id === shopSchedule.shopId);

    return {
      shopId: shopSchedule.shopId,
      shopName: shop.name,
      startDate: shopSchedule.schedules[fieldName].startDate,
      endDate: shopSchedule.schedules[fieldName].endDate,
      workdays: getBarberShopScheduleWithConflicts({
        otherShopsSchedules,
        shopSchedule: shopSchedule.schedules[fieldName],
        shopNamesById,
        shop,
      }).map(item => ({
        ...item,
        hasConflicts: !isEmpty(item.conflicts),
      })),
    };
  });
};

export default getScheduleSummary;
